import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import thunk from "redux-thunk";

import { messages } from "./messages";

const reducer = combineReducers({
  messages
});

// This store supports the redux devtools extension in development.
// This isn't required to use rex, but it's a great tool for developing
// with redux.
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
